// Testing
export const environment = {
    production: true,
    PRIVATE_TESTING: false,
    IS_STAGING: true,

    API_URL: 'https://testing.saideline.com/api/v1',

    localization: {
        defaultLanguage: 'en',
        supportedLanguages: ['en', 'de'],
    },
};
